// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/RelatorioClientes_RelatorioClientesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /relatorios/relatorio_clientes/relatorioClientes
 *
 * Returns the client report — one row per compromisso (see the Row class).
 */
import type { RelatorioClientes_RelatorioClientesRow } from './RelatorioClientes_RelatorioClientesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type RelatorioClientes_RelatorioClientesResponseDados = RelatorioClientes_RelatorioClientesRow[];

export type RelatorioClientes_RelatorioClientesResponse = ApiResponse<RelatorioClientes_RelatorioClientesResponseDados>;

registerResponseContract('RelatorioClientes_RelatorioClientesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      cliente_id:       { type: 'number',  required: true },
      compromisso_id:   { type: 'number',  required: true },
      status:           { type: 'string',  required: false },
      total:            { type: 'number',  required: false },
      cpf:              { type: 'string',  required: true },
      nome:             { type: 'string',  required: true },
      endereco:         { type: 'string',  required: true },
      celular:          { type: 'string',  required: true },
      email:            { type: 'string',  required: false },
      data_hora_inicio: { type: 'string',  required: false },
      data_cadastro:    { type: 'string',  required: false },
      forma_pagamento:  { type: 'string',  required: false },
      franquia:         { type: 'string',  required: false },
      localidade:       { type: 'string',  required: false },
    },
  },
})
